import React from "react";
import { useHistory } from "react-router-dom";
import CommonPage from "@icarius-common/commonPage";
import { Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { getLocalizedString } from "@icarius-localization/strings";
import Masonry from 'react-masonry-css';
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import paths from "@icarius-router/paths";
import TrainingSummary from "./trainingSummary";

const BREAKPOINTS = {
  default: 3,
  1920: 4,
  1440: 4,
  1280: 3,
  960: 2,
  750: 2,
  600: 1,
  480: 1
}

const TrainingSelection = (props) => {

  const {
    isLoading,
    activeList,
    finishedList,
    canViewStats,
    handleSelect,
    handleShowParticipants,
    handleDownloadCertificates,
    handleOpenStatsPage,
  } = props;

  const history = useHistory();

  const goBackButton = () => (
    <CustomIconButton
      title={getLocalizedString("goBack")}
      type={"goBack"}
      onClick={() => history.push(paths.trainingAndDevelopment)}
    />
  )

  const statsButton = () => canViewStats && (
    <CustomIconButton
      title={getLocalizedString("viewStats")}
      onClick={handleOpenStatsPage}
      type={"graphics"}
    />
  )

  return (
    <CommonPage
      title={getLocalizedString("lms")}
      isLoading={isLoading}
      menuItems={[goBackButton, statsButton]}
      isNotGridPage
    >
      <div>
        {
          [
            {
              title: getLocalizedString("activeTraining"),
              noDataString: getLocalizedString("noActiveTraining"),
              data: activeList,
            },
            {
              title: getLocalizedString("finishedTraining"),
              noDataString: getLocalizedString("noFinishedTraining"),
              data: finishedList,
            },
          ].map((list, index) => {
            if (list.data === null) return null;

            return (
              <div
                key={index}
                style={{
                  margin: "10px 24px",
                  marginBottom: 40,
                }}
              >
                <Typography
                  className="whiteText"
                  style={{
                    fontSize: 20,
                    marginBottom: 15,
                  }}
                >
                  {list.title}
                </Typography>
                {
                  !Boolean(list.data.length) &&
                  <div style={{ width: '100%' }}>
                    <Alert variant="filled" severity="info">
                      {list.noDataString}
                    </Alert>
                  </div>
                }
                <div className="flex flex-wrap w-full">
                  <Masonry
                    breakpointCols={BREAKPOINTS}
                    className="my-masonry-grid flex w-full"
                    columnClassName="my-masonry-grid_column flex flex-col p-8 py-0"
                  >
                    {
                      list.data.map((item) => {
                        return (
                          <div key={item.id} className={"mb-16"}>
                            <TrainingSummary
                              isActive={index === 0}
                              data={item}
                              handleOpen={() => handleSelect(item.id)}
                              handleShowParticipants={() => handleShowParticipants(item.id)}
                              handleDownloadCertificates={() => handleDownloadCertificates(item.id)}
                            />
                          </div>
                        )
                      })
                    }
                  </Masonry>
                </div>
              </div>
            )
          })
        }
      </div>
    </CommonPage>
  )
}

export default TrainingSelection;